<template>
  <div id="app">
    <router-view />
    <Toast />
    <LoadingGlobal />
    <NotificationContainer />
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from './stores/auth.ts'
import { initializeStatusBar } from './services/capacitor'
import Toast from './components/ui/Toast.vue'
import LoadingGlobal from './components/LoadingGlobal.vue'
import NotificationContainer from './components/NotificationContainer.vue'

const authStore = useAuthStore()
const route = useRoute()

const isPasswordRecoveryRoute = (path = '') =>
  path.includes('/forgot-password') || path.includes('/reset-password/')

onMounted(async () => {
  // Initialize status bar for safe-area support
  await initializeStatusBar()

  if (isPasswordRecoveryRoute(route.path)) {
    console.log('[DeepLinkDebug][App] pulando checkAuth na rota de recuperação', {
      path: route.path
    })
    return
  }

  // Inicializar autenticação (carrega dados do usuário se houver token)
  if (authStore.token) {
    try {
      await authStore.checkAuth()
    } catch (error) {
      console.error('Erro ao verificar autenticação:', error)
    }
  }
})
</script>

<style>
:root {
  --bloop-green: #7ED321;
  --bloop-green-dark: #6BA82A;
  --bloop-dark: #0D1117;
  --bloop-gray: #161B22;
  --bloop-light-gray: #21262D;
  --bloop-text: #F0F6FC;
  --bloop-text-muted: #7D8590;
  --surface: #161B22;
  --surface-secondary: #0D1117;
  --border-color: #30363D;
  --border-focus: #7ED321;
}

* {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  box-sizing: border-box;
}

body {
  background: var(--surface-secondary);
  color: var(--bloop-text);
  margin: 0;
  padding: 0;
  min-height: 100vh;
  overflow-x: hidden;
}

#app {
  min-height: 100vh;
}
</style>
